import axios from "../api/axios";
import useData from "./useData";
import { useToken } from "./useToken";

const useLogout = () => {
    const { setAuth } = useData();
    const [, setToken] = useToken();

    const logout = async () => {

        // Clear client auth state immediately
        setAuth(null);
        setToken(null);

        try {
            await axios.post(
                "/api/logout",
                {},
                {
                    withCredentials: true,
                }
            );

        } catch (err) {
            console.error(
                "⚠️ useLogout: API logout failed:",
                err.message
            );
        }
    };

    return logout;
};

export default useLogout;